// extracted by mini-css-extract-plugin
export default {"sidebar":"BurgerSideBar_sidebar__RItUr","open":"BurgerSideBar_open__ah4Kx","burgerImage":"BurgerSideBar_burgerImage__hkw2a","closeBtn":"BurgerSideBar_closeBtn__6Zxgz"};